import { render, staticRenderFns } from "./ButtonTile.vue?vue&type=template&id=02065dd2&"
import script from "./ButtonTile.vue?vue&type=script&lang=js&"
export * from "./ButtonTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports